import ReactGA from "react-ga4";
import { format } from "date-fns";
import { useSelector } from "react-redux";

const { REACT_APP_GA_TRACKING_ID } = process.env;

const useReactGASend = () => {
  const trackingId = REACT_APP_GA_TRACKING_ID;
  const sessionId = useSelector((state) => state.checkArsStatus.channelId);
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const branchId = useSelector((state) => state.checkArsStatus.branchId);
  const branchName = useSelector((state) => state.checkArsStatus.branchName);
  const ticketId = useSelector((state) => state.connectChatServer.ticketId);
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const channelId = useSelector((state) => state.checkArsStatus.channelId);

  const selectedBranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );

  const selectedBranchName = useSelector(
    (state) => state.getBranches.selectedBranchName
  );

  const makeEventTrackFn = ({
    category,
    action,
    body = {},
    eventType = "click",
  }) => {
    const now = new Date();
    const date = format(now, "yyyyMMdd");
    const time = format(now, "HHmmss");
    const data = {
      category,
      action,
      key1_timestamp_yyyymmdd: date,
      key2_timestamp_hh24miss: time,
      key3_sessionid: sessionId, //세션아이디 (channel id)
      key4_userid: userId, //사용자아이디
      key5_event_type: eventType, // 이벤트 (Default : click)
      key6_branch_id: branchId || selectedBranchId,
      key7_branch_name: branchName || selectedBranchName,
      key8_ticket_id: ticketId,
      key9_brand_id: brandId, // 업태 코드
      url: window.location.href,
      ...body,
    };

    if (trackingId) {
      // console.log(data);
      ReactGA.ga("set", "userId", channelId);
      ReactGA.event(action, data);
    } else {
      // console.log(data);
    }
  };

  return { makeEventTrackFn };
};

export default useReactGASend;
